/*
 * Shared collection slider — NATIVE CSS SCROLL-SNAP (no Swiper).
 *
 * Markup contract (per slider):
 *   <div data-swiper-scope>
 *     <div class="tmg-swiper">
 *       <div class="tmg-track">
 *         <div class="tmg-slide">…</div>
 *       </div>
 *     </div>
 *     <div class="tmg-swiper__controls">
 *       <button class="tmg-swiper__arrow" data-swiper-prev>…</button>
 *       <div class="tmg-swiper__progress" data-swiper-progress></div>
 *       <button class="tmg-swiper__arrow" data-swiper-next>…</button>
 *     </div>
 *   </div>
 *
 * Slides-per-view and gaps are pure CSS (--tmg-slides / --tmg-gap in
 * tmg-collection-swiper.css), so there is no per-slider construction cost —
 * Swiper used to cost ~29ms of main-thread work per instance, during scroll,
 * which is exactly when taps land. This file only wires what CSS can't do:
 * arrows, the segmented progress bar, a desktop mouse-drag shim, and a
 * smooth-scroll fallback for Safari < 15.4.
 */
(function () {
  // Guard against the many duplicate <script> tags (one per section that uses this).
  if (window.__tmgCollectionSwiperInit) return;
  window.__tmgCollectionSwiperInit = true;

  var SUPPORTS_SMOOTH =
    typeof document !== 'undefined' &&
    'scrollBehavior' in document.documentElement.style;

  function scrollToLeft(el, left) {
    var max = el.scrollWidth - el.clientWidth;
    var target = Math.max(0, Math.min(left, max));

    if (SUPPORTS_SMOOTH) {
      el.scrollTo({ left: target, behavior: 'smooth' });
      return;
    }

    // Safari < 15.4: animate by hand so arrows glide instead of jumping.
    var start = el.scrollLeft;
    var delta = target - start;
    if (!delta) return;
    var duration = 320;
    var startTime = null;

    function step(now) {
      if (startTime === null) startTime = now;
      var p = Math.min((now - startTime) / duration, 1);
      var eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      el.scrollLeft = start + delta * eased;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initOne(viewport) {
    if (!viewport || viewport.dataset.snapReady === '1') return;
    viewport.dataset.snapReady = '1';

    var scope = viewport.closest('[data-swiper-scope]') || viewport.parentElement;
    var prevBtn = scope.querySelector('[data-swiper-prev]');
    var nextBtn = scope.querySelector('[data-swiper-next]');
    var progress = scope.querySelector('[data-swiper-progress]');

    var pages = 0;

    function pageCount() {
      var w = viewport.clientWidth;
      if (!w) return 1;
      return Math.max(1, Math.round(viewport.scrollWidth / w));
    }

    function activePage() {
      var max = viewport.scrollWidth - viewport.clientWidth;
      if (max <= 0) return 0;
      return Math.round((viewport.scrollLeft / max) * (pageCount() - 1));
    }

    function buildSegments() {
      if (!progress) return;
      var total = pageCount();
      if (pages === total) return;
      pages = total;

      progress.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var seg = document.createElement('div');
        seg.className = 'tmg-swiper-segment';
        seg.setAttribute('data-index', i);
        (function (index) {
          seg.addEventListener('click', function () {
            scrollToLeft(viewport, index * viewport.clientWidth);
          });
        })(i);
        progress.appendChild(seg);
      }
    }

    function onUpdate() {
      buildSegments();

      if (progress) {
        var active = activePage();
        Array.prototype.forEach.call(progress.children, function (seg, i) {
          seg.classList.toggle('active', i === active);
        });
      }

      var max = viewport.scrollWidth - viewport.clientWidth;
      if (prevBtn) prevBtn.disabled = viewport.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = viewport.scrollLeft >= max - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToLeft(viewport, viewport.scrollLeft - viewport.clientWidth);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToLeft(viewport, viewport.scrollLeft + viewport.clientWidth);
      });
    }

    viewport.addEventListener('scroll', onUpdate, { passive: true });

    // A slider inside a hidden tab panel has clientWidth 0. When the panel is
    // shown the element resizes, and this recomputes pages/segments — which is
    // why the old force-init hook is no longer needed.
    if ('ResizeObserver' in window) {
      new ResizeObserver(onUpdate).observe(viewport);
    } else {
      window.addEventListener('resize', onUpdate);
    }

    // ---- Desktop mouse click-drag shim ----
    // Native overflow covers touch, trackpad and wheel, but not mouse drag.
    var down = false, startX = 0, startLeft = 0, moved = false;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      viewport.scrollLeft = startLeft - dx;
    });

    function endDrag() {
      if (!down) return;
      down = false;
      viewport.classList.remove('is-dragging');
      var w = viewport.clientWidth;
      if (w) scrollToLeft(viewport, Math.round(viewport.scrollLeft / w) * w);
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    // Suppress the click that ends a drag so it doesn't open a product page.
    viewport.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    onUpdate();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.tmg-swiper'), initOne);
  }

  // Kept for backwards compatibility: sections that reveal a hidden panel used
  // to call this to force Swiper to initialize. Scroll-snap needs no init, but
  // wiring any not-yet-observed slider here is harmless and cheap.
  window.tmgInitCollectionSwipers = initAll;

  function setup() {
    var els = document.querySelectorAll('.tmg-swiper');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      initAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            obs.unobserve(entry.target);
            initOne(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  // ---- Reset restored scroll offsets ----
  // These rows are `overflow-x: auto`, so the browser (notably iOS Safari)
  // records each one's scrollLeft and restores it on reload and on bfcache
  // restore. A row the shopper had swiped then comes back mid-way, looking
  // half-scrolled. Swiper never had this problem because it moved slides with
  // transforms — there was no scroll offset to restore. Product rows should
  // always open at the first card, so put them back.
  // ---- Reset restored scroll offsets (lazily) ----
  // These rows are `overflow-x: auto`, so iOS Safari records each one's
  // scrollLeft and restores it on reload and on bfcache restore — a row the
  // shopper had swiped comes back mid-way, looking half-scrolled. Swiper never
  // had this problem because it moved slides with transforms; there was no
  // scroll offset to restore.
  //
  // Correcting all rows in one sweep measured ~12ms, because every scrollLeft
  // write makes the scroller re-snap (scroll-snap-type: mandatory). Batching
  // reads before writes did NOT help — the cost is the writes themselves. So
  // correct each row only as it nears the viewport: a typical visit sees 3-4 of
  // them, and rows never scrolled to are never touched.
  var resetObserver = null;

  function armScrollReset() {
    var els = document.querySelectorAll('.tmg-swiper');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) {
        if (els[i].scrollLeft) els[i].scrollLeft = 0;
      }
      return;
    }

    // Drop the previous generation so repeated bfcache restores don't stack up
    // observers holding references to rows that were never scrolled into view.
    if (resetObserver) resetObserver.disconnect();

    resetObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          var el = entry.target;
          if (!el.scrollLeft) return;
          // scroll-behavior: smooth would animate the correction and be visible.
          var prev = el.style.scrollBehavior;
          el.style.scrollBehavior = 'auto';
          el.scrollLeft = 0;
          el.style.scrollBehavior = prev;
        });
      },
      { rootMargin: '200px 0px' }
    );

    Array.prototype.forEach.call(els, function (el) { resetObserver.observe(el); });
  }

  function boot() {
    setup();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }

  // `pageshow` fires on the first load AND on every bfcache restore, and always
  // after Safari has restored offsets — so it is the only hook needed.
  window.addEventListener('pageshow', armScrollReset);
})();
